import React from "react";
import { useSelector } from "react-redux";
import cx from "classnames";
import { selectActiveMatchingCampaign } from "../../../../../redux/slices/matchingCampaignsSlice";
import { selectCmsControlByIdByPage } from "../../../../../redux/slices/cmsSettingsSlice";
import { selectCurrentPage } from "../../../../../redux/slices/appSettingsSlice";
import MatchingCampaignsCallout from "./MatchingCampaignsCallout";
import "./MatchingCampaignsCallout.scss";

/**
 * @param {object} props
 * @param {number} props.controlId
 * @returns {React.ReactElement}
 */
const ConnectedMatchingCampaignsCallout = ({ controlId }) => {
    const currentPage = useSelector(selectCurrentPage);
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(state, controlId, currentPage),
    );
    const { options = {} } = control;
    const {
        oneTimeMatchingCampaignsTabHeading = "Your gift will be matched by %SPONSORNAME%!",
        recurringMatchingCampaignsTabHeading = "Your first gift will be matched by %SPONSORNAME%!",
        hideMatchingCampaignsCountdown = false,
    } = options;

    const { endDate = "", setEndDate = false } = useSelector(
        selectActiveMatchingCampaign,
    );

    const shouldDisplayCountdown =
        !!setEndDate && !hideMatchingCampaignsCountdown && endDate;

    const matchingCampaignsCalloutProps = {
        endDate,
        matchingCampaignsContentProps: {
            oneTimeMatchingCampaignsTabHeading,
            recurringMatchingCampaignsTabHeading,
            shouldDisplayCountdown,
        },
        ribbonWrapperProps: {},
        shouldDisplayCountdown,
    };

    return (
        <div
            className={cx(
                "col",
                "col--12",
                shouldDisplayCountdown && "-margin-top--30",
            )}
        >
            <MatchingCampaignsCallout {...matchingCampaignsCalloutProps} />
        </div>
    );
};

export default ConnectedMatchingCampaignsCallout;
